import { render, staticRenderFns } from "./TableManagerSettings.vue?vue&type=template&id=8bf14390&scoped=true&"
import script from "./TableManagerSettings.vue?vue&type=script&lang=ts&"
export * from "./TableManagerSettings.vue?vue&type=script&lang=ts&"
import style0 from "./TableManagerSettings.vue?vue&type=style&index=0&id=8bf14390&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf14390",
  null
  
)

export default component.exports